module.exports = __webpack_public_path__ + "img/send parcel (1).de0a6f9d.svg";